import { ORGANIZATIONS } from '../constants';

export const USERS = 'users';

export const goToUsers = orgId => `${ORGANIZATIONS}/${orgId}/${USERS}`;
